import {PaginatedSelectComponent} from "./paginated-select/paginated-select.component";
import {InputComponent} from "./input/input.component";
import {ButtonComponent} from "./button/button.component";
import {SelectComponent} from "./select/select.component";
import {SelectSearchComponent} from "./select/select-search/select-search.component";
import {SelectSearchClearDirective} from "./select/select-search/select-search-clear.directive";
import {SelectInfiniteScrollDirective} from "./select/select-infinite-scroll.directive";
import {AttachmentComponent} from "./attachment/attachment.component";
import {PhoneInputComponent} from "./phone-input/phone-input.component";
import {TimeComponent} from "./time/time.component";
import {TimePickerComponent} from "./time/time-picker.component";
import {RadiobuttonComponent} from "./radiobutton/radiobutton.component";
import {CheckboxComponent} from "./checkbox/checkbox.component";
import {TextareaComponent} from "./textarea/textarea.component";
import {DynamicFieldDirective} from "./dynamic-field/dynamic-field.directive";
import {MainDynamicFormComponent} from "./main-dynamic-form/main-dynamic-form.component";
import {GroupSelectComponent} from "./group-select/group-select.component";
import {DateComponent} from "./date/date.component";
import {
  PaginatedSelectTableComponent
} from "./paginated-select/paginated-select-table/paginated-select-table.component";
import {HoursDirective} from "./app-time-picker/hours.directive";
import {MinutesDirective} from "./app-time-picker/minutes.directive";
import {TimerPickerComponent} from "./app-time-picker/time-picker.component";
import {AppTimePickerComponent} from "./app-time-picker/app-time-picker.component";
import {NumberInputComponent} from "./number-input/number-input.component";
import {DataTableHybridComponent} from "../data-table-hybrid/data-table-hybrid.component";
import {TextEditorComponent} from "./text-editor/text-editor.component";
import {InputChipComponent} from "./input-chip/input-chip.component";
import {ChipComponent} from "./chip/chip.component";
import {InputMapComponent} from "./input-map/input-map.component";
import {DataInputComponent} from "../data-table-hybrid/utility/data-input/data-input.component";
import {DataLabelComponent} from "../data-table-hybrid/utility/data-label/data-label.component";
import {DateFilterComponent} from "../data-table-hybrid/utility/date-filter/date-filter.component";
import {DataStatesComponent} from "../data-table-hybrid/utility/data-states/data-states.component";
import {SearchFieldsComponent} from "../data-table-hybrid/utility/search-fields/search-fields.component";
import {AllDetailsComponent} from "../all-details/all-details.component";

export const DynamicFormsImportExport = [
  //Dynamic Form
  PaginatedSelectComponent,
  InputComponent,
  ButtonComponent,
  SelectComponent,
  SelectSearchComponent,
  SelectSearchClearDirective,
  SelectInfiniteScrollDirective,
  AttachmentComponent,
  PhoneInputComponent,
  TimeComponent,
  TimePickerComponent,
  RadiobuttonComponent,
  CheckboxComponent,
  TextareaComponent,
  DynamicFieldDirective,
  MainDynamicFormComponent,
  GroupSelectComponent,
  DateComponent,
  PaginatedSelectTableComponent,
  HoursDirective,
  MinutesDirective,
  TimerPickerComponent,
  AppTimePickerComponent,
  SelectSearchComponent,
  NumberInputComponent,
  DataTableHybridComponent,
  DataInputComponent,
  DataLabelComponent,
  DateFilterComponent,
  DataStatesComponent,
  SearchFieldsComponent,
  AllDetailsComponent,
  TextEditorComponent,
  InputChipComponent,
  ChipComponent,
  InputMapComponent
]
